<script>
	import { audio_snax_func } from "./audio_snax";
	import { audio_bientot_func } from "./audio_bientot";
	import poles from "./pole";
	let allPole = poles;
	let font = [
		"'Shizuru', cursive",
		"'Roboto', sans-serif",
		"'Noto Sans JP', sans-serif",
	];

	const randomFromInterval = (min, max) => {
		return Math.random() * (max - min + 1) + min;
	};
	const getRandomTime = () => {
		let random = randomFromInterval(0.1, 5);
		return random.toFixed(2);
	};
	const getRandomFont = () => {
		return font[Math.floor(Math.random() * font.length)];
	};
	const randomExcept = () => {
		let valueX = randomFromInterval(0, window.innerWidth);
		let valueY = randomFromInterval(0, window.innerHeight);

		while (
			valueX > (window.innerWidth / 8) * 3 &&
			valueX < window.innerWidth / 8 + window.innerWidth / 2 &&
			valueY > (window.innerHeight / 8) * 3 &&
			valueY < window.innerHeight / 8 + window.innerHeight / 2
		) {
			// not good
			valueX = randomFromInterval(0, window.innerWidth);
			valueY = randomFromInterval(0, window.innerHeight);
		}
		return { x: valueX.toFixed(2), y: valueY.toFixed(2) };
	};
	const getRandomPostion = () => {
		let { x, y } = randomExcept();
		return `top: ${y}px; left: ${x}px;`;
	};
	const getFont = () => {
		return `font-family:${getRandomFont()};`;
	};
	const getRandomStyle = (pole) => {
		const arrayOfDirection = [
			"normal",
			"reverse",
			"alternate",
			"alternate-reverse",
		];
		const arrayOfTiming = [
			"ease",
			"ease-in",
			"ease-out",
			"ease-in-out",
			"linear",
		];
		const randomElement =
			arrayOfDirection[
				Math.floor(Math.random() * arrayOfDirection.length)
			];
		const randomElement2 =
			arrayOfTiming[Math.floor(Math.random() * arrayOfTiming.length)];
		return `animation: ${getRandomTime()}s ${randomElement2} 0s anim infinite ${randomElement};position:absolute;${getRandomPostion()}${getFont()}`;
	};
	window.onresize = () => {
		allPole = [...allPole];
	};
	setInterval(() => {
		allPole = [...allPole];
	}, 10000);
</script>

<main>
	<div
		id="snax"
		on:click={() => {
			audio_snax_func();
		}}
	>
		<span class="snaxText">S</span>
		<span class="snaxText">n</span>
		<span class="snaxText">a</span>
		<span class="snaxText">x</span>
	</div>
	<div id="snaxTextBig">
		<p>
			Le club <span
				class="bold"
				id="petitSnax"
				on:click={() => {
					audio_bientot_func();
				}}
			>
				Snax
			</span>
			de
			<span class="bold">Télécom Paris</span>
			!
		</p>
	</div>
	{#each allPole as pole}
		<a href={pole.href ? pole.href : ""}>
			<div class="divRandom">
				<span class="randomTime" style={getRandomStyle(pole)}>
					Pôle {pole.pole}
				</span>
			</div>
		</a>
	{/each}
	<style>
		@keyframes anim {
			0% {
				color: black;
				transform: rotate(0deg);
			}

			20% {
				color: blue;
			}
			30% {
				color: yellow;
			}
			40% {
				color: green;
			}
			50% {
				color: purple;
			}
			60% {
				color: orange;
			}
			100% {
				color: red;
				transform: rotate(360deg);
			}
		}
	</style>
</main>

<style>
	.bold {
		font-weight: bold;
	}
	#petitSnax:hover {
		font-size: 1.5em;
		cursor: pointer;
		font-family: "Rancho", cursive;
		font-weight: 900;
	}
	main {
		position: absolute;
		width: 100%;
		height: 100%;
		overflow: hidden;
		text-align: center;
	}
	.divRandom {
		cursor: pointer;
		font-size: 0.2em;
	}
	#snax {
		cursor: pointer;
		display: inline-block;
		font-size: 3em;
		margin: 0;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	#snaxTextBig {
		display: inline-block;
		font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
			Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
		font-size: 2em;
		margin: 0;
		position: absolute;
		top: 70%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.snaxText {
		font-family: "Rancho", cursive;
	}
	.randomTime {
		position: absolute;
		font-size: 16px;
		display: inline-block;
		font-family: sans-serif;
		font-weight: bold;
	}
	.randomTime:hover {
		font-size: 25px;
		animation: 5s linear 0s anim2 infinite !important;
	}
	.snaxText {
		font-size: 4em;
		animation: 2s linear 0s anim infinite alternate;
		display: inline-block;
		font-weight: bold;
	}
	/* @keyframes anim2 {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	} */
</style>
